"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @TODO: no sens anymore
exports.default = () => (icon) => icon.iconSolid;
//# sourceMappingURL=isActiveIcon.js.map